/**
 * @file lib.ts
 * @path packages/core/src/utils/lib.ts
 * @type TypeScript Module
 * @description Utility or helper module
 */

import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
